<template>
<div class="chapter">
<div class="inner_page">
<blockquote>
<p class="ind" id="quote" style="margin-top:20px;">For every man the world is as fresh as it was at the first day,</p>
<p class="ind">And as full of untold novelties for him who has the eyes to see them.</p>
<p class="right" style="margin-top:20px;">—Thomas Henry Huxley, English biologist,</p>
<p class="right">1825–1895</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4quote.vue?9f11e598